import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-battery-and-signal',
  templateUrl: './battery-and-signal.component.html',
})
export class BatteryAndSignalComponent {
    @Input() batteryPercentage: number | undefined = undefined;
    @Input() signal: number | undefined = undefined;
    @Input() view: string[] = ['battery', 'signal'];
}
